import { Field } from '@components/common/forms/constants';

export const DEFAULT_VEHICLE_FORM_RULES = {
  [Field.VehicleType]: [{ required: true, message: 'Укажите тип транспортного средства' }],
  [Field.VehicleUnloadType]: [{ required: true, message: 'Укажите тип разгрузки' }],
  [Field.VehicleLoadType]: [{ required: true, message: 'Укажите тип погрузки' }]
};
